<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="mdi-file-document-edit-outline"
      :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <ValidationObserver ref="news">
        <v-row class="mx-1">
          <v-col cols="8" class="content_category rounded-lg">
            <v-row class="mx-3">
              <v-col cols="12">
                <ValidationProvider
                  name="type"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="items"
                    label="Chọn loại"
                    item-text="text"
                    item-value="value"
                    v-model="newsDetail.type"
                  ></v-select>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                    v-model="newsDetail.is_promotional"
                    label="Khuyến mại"
                    color="primary"
                ></v-checkbox>
              </v-col>

              <v-col cols="12">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Tên bài viết"
                    placeholder="Nhập tên bài viết"
                    v-model="newsDetail.name"
                    :rules="[checkChar]"
                    counter
                  ></v-text-field>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>

              <v-col cols="12">
                <ValidationProvider
                  name="slug"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Slug"
                    placeholder="Nhập slug"
                    v-model="newsDetail.slug"
                    @blur="triggerSeo"
                  ></v-text-field>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
                <v-col cols="12">
                <ValidationProvider
                  name="Mô tả"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                   class="content-textarea"
                    background-color="#EDF2F7"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả"
                    v-model="newsDetail.description"
                    :rules="[checkCharDescription]"
                    counter
                  ></v-textarea>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
                <v-col cols="12">
                <add-module @inputData="addModule">
                </add-module>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  name="description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <ck-content class="ck-news" :content="ck_content" @getData="value => ck_content = value"  @getSeo="triggerSeo"/>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
              <v-col cols="6">
                <v-row class="">
                  <v-col>
                    <h4>No-index</h4>
                    <div>
                      <v-switch
                          v-model="no_index"
                      ></v-switch>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  name="meta_title"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    background-color="#EDF2F7"
                    @blur="triggerSeo"
                    filled
                    label="SEO Title"
                    placeholder="Nhập SEO Title"
                    v-model="newsDetail.meta_title"
                  ></v-text-field>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  name="meta_description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    class="content-textarea"
                    background-color="#EDF2F7"
                    filled
                    label="SEO Description"
                    @blur="triggerSeo"
                    placeholder="Nhập mô tả"
                    v-model="newsDetail.meta_description"
                  >
                  </v-textarea>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" v-if="newsDetail.type == 2">
                <ValidationProvider
                  name="video_url"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="URL video"
                    placeholder="Nhập URL của video"
                    v-model="newsDetail.video_url"
                  ></v-text-field>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" class="content_category rounded-lg ml-3 pa-0 ma-0">
            <div>
              <h4 class="mb-3 mt-3 ml-3">Category</h4>
              <v-divider></v-divider>
              <div
                class="overflow-x-auto pa-0 ma-0"
                id="scroll-target"
                style="max-height: 1020px"
              >
                <div
                  class="mx-3"
                  v-scroll.#scroll-target="onScroll"
                  style="height: 1020px"
                >
                  <v-radio-group v-model="newsDetail.category_id" column>
                      <div v-for="item in category" v-bind:key="item.id">
                        <v-row>
                          <v-col cols="10" class="d-flex align-center">
                            <v-checkbox
                              v-model="checkbox_category"
                              @change="checkedCategory(item.id)"
                              :value="item.id"
                              :label="item.name"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2" class="d-flex align-end">
                            <v-radio :value="item.id"></v-radio>
                          </v-col>
                        </v-row>
                      </div>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="8" class="content_category mt-3 rounded-lg">
            <v-col cols="6">
                <v-file-input
                  label="Ảnh tiêu đề"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileSelected"
                ></v-file-input>
              <v-img
                :src="changeImage === '' ? url + src : src"
              ></v-img>
              <v-text-field 
                  background-color="#EDF2F7"
                  filled
                  label="Alt ảnh đại diện"
                  v-model="newsDetail.alt_image"
                  placeholder="Nhập alt"
              ></v-text-field>
            </v-col>
          </v-col>
          <v-col cols="3" class="content_category rounded-lg ml-3 mt-3">
            <div class="mx-2">
              <h4 class="mb-2">Product tags</h4>
              <v-divider></v-divider>
              <div>
                <ValidationProvider
                  name="tag"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="list_tag_id"
                    :items="list_tags"
                    item-value="id"
                    item-text="name"
                    chips
                    label="Tags"
                    multiple
                    outlined
                  ></v-autocomplete>
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </v-col>


          <seo 
            @getKeywords="getKeywords"
            :trigger_seo="count_trigger_seo"
            :text_seo="text_seo"
            :keywords="newsDetail.meta_keyword"
            :meta_title="newsDetail.meta_title"
            :content="ck_content"
            :slug="newsDetail.slug"
            :meta_description="newsDetail.meta_description"
          />

          <v-col cols="8" class="text-center">
            <v-btn @click="save_news()" color="primary" width="180">
              Lưu
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import {
  GET_DETAIL_NEWS,
  GET_LIST_CATEGORIES,
  UPLOAD_NEWS_IMAGE,
  UPDATE_NEWS,
} from "@/store/modules/news";
import { GET_LIST_TAG } from "@/store/modules/tag";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";
import { mapGetters } from "vuex";
import CkContent from "@/components/ck-content"
import { replaceCkContent } from '@/utils/helpers'
import Seo from "@/components/seo"
import AddModule from "@/views/Pages/production/add_module"
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CkContent,
    AddModule,
    Seo
  },
  mounted() {
    localize({
      vi: {
        names: {
          type: "Loại",
          name: "Tên",
          slug: "Slug",
          content: "Nội dung bài viết",
          meta_title: "SEO Title",
          meta_description: "SEO Description",
          meta_keyword: "SEO Keyword",
          video_url: "Video URL",
          category: "Category",
          image: "Ảnh tiêu đề",
          tag: "Tags",
        },
        messages: {
          required: "{_field_} " + "không được bỏ trống!",
        },
      },
    });
    localize("vi");
  },
  data() {
    return {
      count_trigger_seo: 0,
      offsetTop: 0,
      ck_content: '',
      text_seo: "",
      errors_ : 0,
      page: "Sửa bài viết",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý bài viết",
          disabled: true,
        },
        {
          text: "Sửa bài viết",
          disabled: true,
        },
      ],
      items: [
        {
          value: 1,
          text: "Bài viết",
        },
        {
          value: 2,
          text: "Video",
        },
      ],
      checked: 1,
      src: "",
      image: {},
      hasImage: false,
      changeImage: "",
      selectedFile: null,
      radio: null,
      list_imgs: [],
      list_img_attribute: [],
      list_tags: [],
      list_tag_id: [],
      url: "",
      SEO: [],
      checkbox_category: null,
      no_index: false
    };
  },
  computed: {
    ...mapGetters({
      newsDetail: "newsDetail",
      category: "category",
      tags: "tags",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL;
    await this.$store.dispatch(`${GET_LIST_CATEGORIES}`);
    await this.$store.dispatch(`${GET_LIST_TAG}`);
    await this.$store.dispatch(`${GET_DETAIL_NEWS}`, this.$route.params.id);
    this.ck_content = this.newsDetail.content
  },
  watch: {
    tags(val) {
      if (val) {
        val.forEach((el) => {
          this.list_tags.push({
            id: el.id,
            name: el.name,
          });
        });
      }
    },
    newsDetail(val) {
      if (val && val.photo_url) {
        this.src = val.photo_url;
      }
      const _this = this;
      if (val && val.list_tag) {
        val.list_tag.forEach((el) => {
          _this.list_tag_id.push(el.id);
        });
      }
      if (val && val.category_ids) {
        this.checkbox_category = val.category_ids;
      }
      if (val && val.content) {
        this.ck_content = val.content;
      }
      if (val && val.no_index) {
        this.no_index = val.no_index == 1 ? true : false;
      }
      this.$forceUpdate();
    },
  },
  methods: {
    checkCharDescription(value){
      if(value.length <= 70 || value.length >= 160){
        return 'Mô tả bài viết khuyến nghị từ 70 - 160 kí tự';
      }
    },
    checkChar(value){
      if(value.length <= 60 || value.length >= 65){
        return 'Tiêu đề bài viết khuyến nghị từ 60 - 65 kí tự';
      }
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    addModule(val) {
      let a = "#####" + JSON.stringify(val) + "#####"
      this.ck_content = this.ck_content + a;
    },
    checkedCategory(id) {
      if (this.newsDetail.category_ids.indexOf(id) != -1) {
        this.newsDetail.category_ids = this.newsDetail.category_ids.filter(
          (item) => {
            return item != id;
          }
        );
      } else {
        this.newsDetail.category_ids.push(id);
      }
    },

    fileSelected(event) {
      if (!event) {
        this.src = "";
        this.newsDetail.photo_url = "";
      }
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "posts");
      this.$store.dispatch(`${UPLOAD_NEWS_IMAGE}`, formData).then((data) => {
        this.newsDetail.photo_url = data.data.data[0].path;
        this.newsDetail.alt_image = "";
      });
    },
    save_news() {
      const _this = this;
      //list tags
      this.list_tag_id.forEach((id) => {
        let tag = _this.list_tags.find((el) => el.id == id);
        _this.newsDetail.list_tag.push({
          id: tag.id,
          name: tag.name,
        });
      });
      if(this.newsDetail.is_promotional == true){
        this.checked = 1
      }else {
        this.checked = 0
      }
      let data_news = {
        id: this.newsDetail.id,
        name: this.newsDetail.name,
        type: this.newsDetail.type,
        content: replaceCkContent(this.ck_content),
        slug: this.newsDetail.slug,
        description : this.newsDetail.description,
        meta_title: this.newsDetail.meta_title,
        meta_keyword: this.newsDetail.meta_keyword,
        meta_description: this.newsDetail.meta_description,
        category_id: this.newsDetail.category_id,
        video_url: this.newsDetail.video_url,
        photo_url: this.newsDetail.photo_url,
        list_tag: JSON.stringify(this.newsDetail.list_tag),
        category_ids: JSON.stringify(this.newsDetail.category_ids),
        is_promotional: this.checked,
        alt_image: this.newsDetail.alt_image,
        no_index: this.no_index
      };
      this.$store.dispatch(`${UPDATE_NEWS}`, data_news).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.go(-1);
        }
        else{
          alert(data.data.errors)
        }
      });
    },
    triggerSeo(){
      this.count_trigger_seo++;
    },
    getKeywords(keywords){
      this.newsDetail.meta_keyword = keywords
    }
  },
};
</script>
<style lang="scss">
.content_category {
  background: #ffffff !important;
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 22px !important;
  }
  .content-textarea.v-textarea .v-input__control{
    display: grid;
  }
}
.ck-news .ck-editor__main .ck-content {
  height: 140px;
}
</style>